import { Box,  Button,  Grid, MenuItem, TextField} from '@mui/material';
import React, { useEffect } from 'react';
import { useAuth0 } from "@auth0/auth0-react";
import { UploadImageButton } from '../../shared/uploadImageButton';
import { useMemberContext } from '../../context/memberContext';
import { FormatJerseyNumber } from '../../models/helpers';



export default function MemberActionImageTab() {

    const [jerseyNumberText, setJerseyNumberText] = React.useState<string>('');
    const [title, setTitle] = React.useState<string>('');
    const [position, setPosition] = React.useState<string>('');
    const [selectedImage, setSelectedImage] = React.useState<string>('');

    const { isAuthenticated} = useAuth0();
    const { rosterData, isLeader,updateJerseyNumber, updateTitle, updatePosition, updateActionImage} = useMemberContext();

     useEffect(() => {
            if (rosterData) {
                setJerseyNumberText(FormatJerseyNumber(rosterData.jerseyNumber, rosterData.jerseyNumberPadding));
                setTitle(rosterData.title ?? '');
                setPosition(rosterData.position ?? '');
            }
        }, [rosterData]);

        const handleJerseyNumberChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
            const { value } = e.target;
            setJerseyNumberText(value);
        };

        const handleTitleChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
            const { value } = e.target;
            setTitle(value);
        };

        const handlePositionChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
            const { value } = e.target;
            setPosition(value);
        };

        const handleUpdateJerseyNumber = async () => {
            await updateJerseyNumber(jerseyNumberText);
        }

        const handleUpdateTitle = async () => {
            await updateTitle(title);
        }

        const handleUpdatePosition = async () => {
            await updatePosition(position);
        }

    return (
        <Grid container spacing={1}>


            <Grid container item xs={12} spacing={1}>

                <Grid item xs={3}>

                    <Box>
                        <TextField id="position"
                            label="Position"
                            variant="outlined"
                            size="small"
                            inputProps={{ maxLength: 18 }}
                            value={position}
                            style={{ width: 250 }}
                            onChange={handlePositionChange} />
                    </Box>

                </Grid>

                <Grid item xs={2}>
                    {isAuthenticated && <Button variant='contained' onClick={handleUpdatePosition}>Update</Button>}
                </Grid>

            </Grid>


      {!isLeader &&
            <Grid container item xs={12} spacing={1}>

                <Grid item xs={3}>

                    <Box>
                        <TextField id="jerseyNumber"
                            label="Jersey Number"
                            variant="outlined"
                            size="small"
                            inputProps={{ maxLength: 3 }}
                            value={jerseyNumberText}
                            style={{ width: 150 }}
                            onChange={handleJerseyNumberChange} />
                    </Box>

                </Grid>

                <Grid item xs={2}>
                    {isAuthenticated && <Button variant='contained' onClick={handleUpdateJerseyNumber}>Update</Button>}
                </Grid>

            </Grid>
}

{isLeader &&
            <Grid container item xs={12} spacing={1}>

                <Grid item xs={3}>

                    <Box>
                    <TextField select
                            label="Select"
                            value={title}
                            size="small"
                            onChange={handleTitleChange}
                            helperText="Select a member type">
                            <MenuItem key='Head Coach' value='Head Coach'>Head Coach</MenuItem>
                            <MenuItem key='Asst Coach' value='Asst Coach'>Asst Coach</MenuItem>
                            <MenuItem key='Team Parent' value='Team Parent'>Team Parent</MenuItem>
                            <MenuItem key='Athletic Trainer' value='Athletic Trainer'>Athletic Trainer</MenuItem>
                            <MenuItem key='Equipment Manager' value='Equipment Mgr'>Equipment Mgr</MenuItem>
                            <MenuItem key='Board' value='Board'>Board</MenuItem>
                            <MenuItem key='Other' value='Other'>Other</MenuItem>
                        </TextField>
                    </Box>

                </Grid>

                <Grid item xs={2}>
                    {isAuthenticated && <Button variant='contained' onClick={handleUpdateTitle}>Update</Button>}
                </Grid>

            </Grid>
}





            <Grid item xs={12}>
                <Grid item>
                    {rosterData?.actionLink && <img src={rosterData.actionLink} height={250} alt='action' />}
                </Grid>

                <Grid item>
                    <Box>
                        <label>Select Action Image</label>
                        {isAuthenticated && 
                            <UploadImageButton id="uploadAction" 
                                               onChange={updateActionImage} 
                                               maxWidth={1000} 
                                               maxHeight={1000} />}
                    </Box>
                </Grid>
            </Grid>
        </Grid>
    )
}